import React from 'react';
import { useTranslation } from 'react-i18next';
import { fetchColors } from '../../../fetchers/mapping';
import { fetchColorsForFilters } from '../../../fetchers/mapping';
import { sortSizes } from '../../../helpers/products';
import { ICategoryFilters } from '../../../models';
import { Filter, FilterType } from '../../../models/filter';
import CategoryFilter from './CategoryFilter';
import GenericFilter from './GenericFilter';

export const NEW_FILTERS_KEYS = [
  'fit',
  'temperature',
  'insulationlevel',
  'activityintensity',
  'sockscushion',
  'socksthickness',
  'socksheight',
  'sockscompression'
];

function Filters({
  filters,
  mobile,
  disabled,
  ui
}: {
  filters: ICategoryFilters | undefined;
  mobile?: boolean;
  disabled: boolean;
  ui?: string;
}) {
  const { t } = useTranslation();
  const colorsCodeToLabel = fetchColorsForFilters();
  const {
    sizes = [],
    colors = [],
    categories = [],
    countCategories = {}
  } = filters || {};
  const sizeFilter: Filter | undefined =
    sizes && sizes.length > 0
      ? {
          name: t(`FILTERS.${FilterType.Size}`),
          options: sizes
            .sort(({ attribute_size: s1 }, { attribute_size: s2 }) =>
              sortSizes(s1, s2)
            )
            .map(size => ({ id: size.label_size, name: size.label_size })),
          code: FilterType.Size
        }
      : undefined;
  const colorFilter: Filter | undefined =
    colors && colors.length > 0
      ? {
          name: t(`FILTERS.${FilterType.Color}`),
          options: colors
            .filter(c => colorsCodeToLabel[c])
            .map(color => {
              const { color: colorLabel = '', image } =
                colorsCodeToLabel[color] || {};
              return {
                id: color,
                name: colorLabel || color,
                image
              };
            }),
          code: FilterType.Color
        }
      : undefined;

  // eslint-disable-next-line sonarjs/no-unused-collection
  const newFilters: Filter[] = [];
  for (const key of NEW_FILTERS_KEYS) {
    if (filters && filters[key]) {
      const f = filters[key];
      newFilters.push({
        name: t(`FILTERS.${key}`),
        code: key,
        options: Object.values(f).map((filter: any) => ({
          id: filter.value,
          name: filter.label
        }))
      });
    }
  }

  return (
    <div className={`sticky top-0`}>
      {sizeFilter && (
        <GenericFilter
          data={sizeFilter}
          mobile={mobile}
          disabled={disabled}
          ui={ui}
        />
      )}
      {colorFilter && (
        <GenericFilter
          data={colorFilter}
          mobile={mobile}
          disabled={disabled}
          ui={ui}
        />
      )}
      {categories && categories.length > 0 && (
        <CategoryFilter
          categories={categories}
          countCategories={countCategories}
          mobile={mobile}
          ui={ui}
        />
      )}
      {/* {newFilters.map((filter, i) => (
        <GenericFilter
          key={i}
          data={filter}
          mobile={mobile}
          disabled={disabled}
        />
      ))} */}
    </div>
  );
}

export default Filters;
